<template>
  <div id="edit-identity-modal">
    <el-dialog v-model="showModal" custom-class="edit-identity-dialog" :close-on-click-modal="false" :close-on-press-escape="false" top="26%">
      <!-- 头部 -->
      <div class="custom-header">
        修改申请人身份
        <!-- 关闭 -->
        <div class="el-dialog__headerbtn" @click="close">
          <i class="el-dialog__close el-icon el-icon-close"></i>
        </div>
      </div>
      <div class="custom-body">
        <div class="sub-tip">不同身份类型，签证资料可能会有区别</div>
        <el-radio-group v-model="checkedId">
          <ul class="identity-list">
            <li
              class="identity-item"
              :class="{'active': checkedId === item.id}"
              v-for="item in identities"
              :key="item.id"
            >
              <el-radio :label="item.id" :disabled="!enableIdentityIds[item.id]">{{item.name}}</el-radio>
            </li>
          </ul>
        </el-radio-group>
      </div>

      <template slot="footer" class="dialog-footer">
        <el-button @click="close">取消</el-button>
        <el-button type="primary" @click="modifyIdentity">确定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import Http from '@/libs/http';
import utils from '../../../libs/utils';

export default {
  name: 'edit-identity-modal',
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false,
    },
    applicantId: {
      type: String,
      default: '',
    },
    productData: {
      type: Object,
      default: null,
    },
    checkedIdentityId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      showModal: this.value,
      identities: [
        {
          id: 0,
          name: '在职人员（企业、事业单位员工）',
        },
        {
          id: 1,
          name: '自由职业者（自由职业、个体经营者）',
        },
        {
          id: 3,
          name: '在校学生（在校学生）',
        },
        {
          id: 4,
          name: '学龄前儿童（学龄前儿童）',
        },
        {
          id: 2,
          name: '退休人员（退休、离休人员）',
        },
      ],
      checkedId: Number(this.checkedIdentityId),
    };
  },
  methods: {
    // 确认修改身份
    modifyIdentity() {
      this.$confirm(
        '不同身份类型的签证资料可能会有差异，申请人变更身份后，可能需要重新上传部分签证资料。',
        '提示',
        {
          confirmButtonText: '确定修改',
          cancelButtonText: '取消',
          type: 'warning',
        },
      )
        .then(() => {
          Http.post('/applicant_identity_update', {
            order_applicant_id: Number(this.applicantId),
            identity_id: this.checkedId,
          }).then(() => {
            this.$emit('updateApplicant');
            this.$emit('input', false);
            utils.msg.success('修改成功');
          });
        })
        .catch(() => {
        });
    },

    close() {
      this.$emit('input', false);
      this.$nextTick(() => {
        this.checkedId = Number(this.checkedIdentityId);
      });
    },
  },
  computed: {
    enableIdentityIds() {
      const identityIds = {
        0: false,
        1: false,
        2: false,
        3: false,
        4: false,
      };
      if (!this.productData) {
        return identityIds;
      }
      const material = this.offline
        ? this.productData.offline_material
        : this.productData.material || [];

      material.forEach((item) => {
        identityIds[item.identity_id] = true;
      });
      return identityIds;
    },
  },
  watch: {
    value(newVal) {
      this.showModal = newVal;
    },
    checkedIdentityId(newVal) {
      this.checkedId = Number(newVal);
    },
  },
};
</script>

<style lang="less">
@import "../../../assets/less/variable";
#edit-identity-modal {
  .edit-identity-dialog {
    top: 30%;
    width: 360px;
    border-radius: 4px;

    .el-dialog__header {
      display: none;
    }

    .el-dialog__body {
      padding: 0;
      .custom-header {
        height: 50px;
        display: block;
        padding: 0 20px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        border-bottom: 1px solid #f0f0f0;
        font-size: 16px;
        color: #333333;
        .el-dialog__close {
          position: absolute;
          right: 20px;
          top: 16px;
          width: 19px;
          height: 19px;
          transform: rotateZ(45deg);
          cursor: pointer;

          &::before {
            content: "";
            display: block;
            width: 19px;
            position: absolute;
            top: 9px;
            left: 0;
            border-top: 1px solid #777;
          }

          &::after {
            content: "";
            display: block;
            height: 19px;
            position: absolute;
            top: 0;
            left: 9px;
            border-left: 1px solid #777;
          }

          &:hover {
            &::before,
            &::after {
              border-color: @main;
            }
          }
        }
      }
      .custom-body {
        padding: 20px 40px 0;
        .sub-tip {
          margin-bottom: 24px;
          font-size: 14px;
          line-height: 1;
          color: #999;
        }
        .identity-list {
          .identity-item {
            font-size: 14px;
            color: #333;
            margin-bottom: 20px;
            &.active .el-radio__label{
              color: #5E9BE1;
            }
          }
        }
      }
    }
    .el-dialog__footer {
      padding: 20px 40px 30px;
      text-align: center;
      font-size: 0;
      .el-button {
        width: 130px;
        font-size: 16px;
        & + .el-button {
          margin-left: 20px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/ordering/modals/edit-identity-modal.vue